import type { ReactNode } from 'react';

import { Button, Icon, IconButton } from '@/components/ui';

interface RepeaterItemProps {
  children: ReactNode;
  onRemove: () => void;
  removeLabel?: string;
}

/**
 * Card-chrome wrapper for a single item inside a list section
 * (Education, Employment, Achievements, etc.). Mirrors the handoff's
 * outlined card with a top-right remove icon.
 */
export function RepeaterItem({ children, onRemove, removeLabel = 'Remove item' }: RepeaterItemProps) {
  return (
    <div
      style={{
        position: 'relative',
        background: 'var(--surface-2)',
        border: '1px solid var(--divider)',
        borderRadius: 'var(--radius-sm)',
        padding: 12,
      }}
    >
      <div style={{ position: 'absolute', top: 6, right: 6 }}>
        <IconButton
          icon="trash"
          iconSize={12}
          size="sm"
          variant="danger"
          label={removeLabel}
          onClick={onRemove}
        />
      </div>
      {children}
    </div>
  );
}

interface AddItemButtonProps {
  onClick: () => void;
  label?: string;
}

export function AddItemButton({ onClick, label = 'Add' }: AddItemButtonProps) {
  return (
    <Button variant="ghost" size="sm" leftIcon={<Icon name="plus" size={12} />} onClick={onClick}>
      {label}
    </Button>
  );
}
